<template>
  <v-container fluid style="overflow: hidden !important;" class="CSChatThai">
    <v-layout row wrap v-if="status_login === 'T'" class="hidden-sm-and-down">
      <v-flex sm12 md12 lg12 xl12 v-if="progress">
        <v-layout row wrap justify-center align-center class="height-100vh">
          <v-progress-circular :size="100" :indeterminate="progress" color="primary"></v-progress-circular>
        </v-layout>
      </v-flex>
      <v-flex sm12 md12 lg12 xl12 v-else>
        <v-content>
          <v-container fluid fill-height>
            <v-layout justify-center class="chatboxnonselect mt-2" column>
              <!-- <v-layout row wrap>
                <v-flex sm4 md4 lg4 xl4 class="ml-50">
                  <p class="text-overflow-groupname">{{detail.group_name}}</p>
                </v-flex>
              </v-layout> -->
              <v-layout justify-center wrap row align-center class="mt-3">
                <v-flex xs10 sm10 md10 lg10 xl10  class="color-card-task ml-3 mr-3">
                  <!-- <v-layout row wrap justify-center align-center class="mb-2 mt-3 ml-4 mr-4">
                    <h2 class="mb-3">{{datetime(time_day)}}</h2>
                    <v-spacer></v-spacer>
                  </v-layout> -->
                  <v-layout row wrap justify-center align-center class="mb-2 mt-3 ml-4 mr-4">
                    <h2 class="mb-3">{{datetimecheck(date)}}</h2>
                    <v-spacer></v-spacer>
                    <v-btn class="btn-create-task mb-3 ml-2" @click="open_create_task()" >
                      <v-icon left class="icon-create-task">fas fa-plus</v-icon>
                        <span>{{$t('Task.allTask.createTask')}}</span>
                    </v-btn>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex
                      xs12
                      class="mb-2 mt-0 ml-2"
                    >
                      <v-sheet height="500" v-if="!progress_project">
                        <v-calendar
                          ref="calendar"
                          v-model="date2"
                          :now="start"
                          :value="date"
                          :locale="$t('Task.allTask.localepicker')"
                          color="primary"
                        > 
                          <template slot='day' slot-scope="date">
                              <template v-for="(member, index) in listdataTask">
                                <v-layout :key="index" row wrap v-if="member.time == date.date">
                                  <v-menu v-model="member.dialog" style="width: 100%" :nudge-width="300" :close-on-content-click="false">
                                    <div slot="activator" style="width: 100%">
                                      <template v-for="(roomname, index2) in member.task">
                                        <div
                                          @click="get_task_in_day(member.time, roomname)"
                                          :key="index2"
                                          v-if="index2 < 2"
                                          class="my-event"
                                          v-html="roomname"
                                        >
                                        </div>
                                      </template>
                                      <div
                                        @click="get_task_in_day(member.time)"
                                        style="cursor: pointer;"
                                        v-if="member.task.length > 2"
                                      >
                                        <p style="font-size: 11px;">{{$t('Task.allTask.detailProject')}}</p>
                                      </div>
                                    </div>
                                    <v-card>
                                      <v-toolbar dense dark color="#1a222c">
                                        <p style="font-size: 14px;" class="mt-3" v-if="checkroomname">{{checkroomname}} ({{datetime(date)}})</p>
                                        <p style="font-size: 14px;" class="mt-3" v-else>{{$t('HeaderMenubar.project')}} ({{datetime(date)}})</p>
                                        <v-spacer></v-spacer>
                                        <v-icon
                                          right
                                          @click="member.dialog = false"
                                        >
                                          mdi-close
                                        </v-icon>
                                      </v-toolbar>
                                      <v-layout class="ml-3 mt-3">
                                        <v-text-field
                                          v-model="search"
                                          solo
                                          :label="$t('Task.allTask.placeholderSearchProject')"
                                          clearable
                                          append-icon="search"
                                          class="searchBox"
                                        ></v-text-field>
                                      </v-layout>

                                      <v-layout wrap align-center justify-center fill-height style="background-color:#f4f1f1; border-radius: 20px" class="mr-3 ml-3 mt-1">
                                          <v-layout align-start justify-end row fill-height style="height: calc(100vh - 530px) !important; overflow-y: auto;" class="taskScroll" >
                                            <v-flex>
                                              <v-layout v-if="progress_task" justify-center align-center  style="height: 25vh !important; ">
                                                <v-progress-circular :size="40" :indeterminate="progress_task" color="primary"></v-progress-circular>
                                              </v-layout>
                                              <v-layout class="mr-3 ml-3 mb-2" v-for="(item,i) in FilterListProject" :key="i" column v-else-if="listproject.length != 0">
                                                <v-layout row wrap class="mb-2 mt-2" v-if="listproject.length != 0">
                                                  <v-flex class="text-xs-left">
                                                    <h3 class="text-overflow-projectname">{{item.project_name}}</h3>
                                                  </v-flex>
                                                  <v-flex class="text-xs-right mt-1">
                                                    <span class="text-overflow-groupname">{{item.room_name}}</span>
                                                  </v-flex>
                                                </v-layout>
                                                <v-expansion-panel>
                                                  <v-expansion-panel-content v-for="(state,index) in item.state" v-if="state.member.length != 0" expand-icon="mdi-menu-down">
                                                    <div slot="header" v-if="state.member.length != 0">{{state.name}}
                                                      <span class="span-numtask">{{$t('Task.allTask.numTask',{count: state.member.length})}}</span>
                                                    </div>
                                                    <v-card>
                                                      <v-list>
                                                        <template v-for="(member, indexmember) in state.member">
                                                          <v-list-tile  
                                                            avatar 
                                                            :key="member._id" 
                                                            @click="open_detail_task(member._id, listproject[i].tokenroom)"
                                                            :class="checkpriorityTask(member.priority)">
                                                              <v-list-tile-content>
                                                                <v-list-tile-title>
                                                                  <v-layout row wrap>
                                                                    <span class="pl-2">{{member.title}}</span>
                                                                    <v-spacer></v-spacer>
                                                                    <v-icon color="#d8d8d8" style="font-size: 19px;" v-if="member.count_comment != '0'">fas fa-comment-dots</v-icon>
                                                                    <span class="ml-2 mr-2" style="color: #515050; font-size: 13px;" v-if="member.count_comment != '0'">{{member.count_comment}}</span>
                                                                    <span class="ml-3" style="color: #515050; font-size: 13px;">{{datetime(member.time_end)}}</span>
                                                                  </v-layout>
                                                                </v-list-tile-title>
                                                              </v-list-tile-content>
                                                          </v-list-tile>
                                                          <v-divider v-if="indexmember + 1 < state.member.length" :key="indexmember"></v-divider>
                                                        </template>
                                                      </v-list>
                                                    </v-card>
                                                  </v-expansion-panel-content>
                                                </v-expansion-panel>
                                              </v-layout>
                                              <v-layout row wrap align-center justify-center fill-height v-else class="mt-5">
                                                <h4 >{{$t('Task.allTask.noCardTask')}}</h4>
                                              </v-layout>
                                            </v-flex>
                                          </v-layout>
                                      </v-layout>
                                      <v-card-actions>
                                      </v-card-actions>
                                    </v-card>
                                  </v-menu>
                                </v-layout>
                              </template>
                          </template>
                        </v-calendar>
                      </v-sheet>
                      <v-sheet style="background-color: #fff0;" height="500" v-else>
                        <v-layout row wrap justify-center align-center>
                          <v-progress-circular style="margin-top: 100px;" :size="100" :indeterminate="progress_project" color="primary"></v-progress-circular>
                        </v-layout>
                      </v-sheet>
                    </v-flex>
                    <v-flex
                      class="text-sm-left ml-3 mb-2"
                    >
                      <v-btn class="btn_prev_next" @click="$refs.calendar.prev()">
                        {{$t('Register.Button.back')}}
                      </v-btn>
                    </v-flex>
                    <v-flex
                      class="text-sm-right mb-2"
                    >
                      <v-btn class="btn_prev_next" @click="$refs.calendar.next()">
                        {{$t('Task.allTask.next')}}
                      </v-btn>
                    </v-flex>

                    
                    <!-- <v-flex sm5 md5 lg5 xl5>
                      <v-layout wrap  align-center justify-center fill-height>
                        <v-date-picker
                          width = "100%"
                          no-title
                          v-model="date2"
                          :event-color="functionEventsColor"
                          :events="functionEvents"
                          year-icon="mdi-calendar-blank"
                          :locale="$t('Task.allTask.localepicker')"
                          color="#2561b0"
                          style="margin-left:20px; margin-right:20px;"
                        ></v-date-picker>
                      </v-layout>
                    </v-flex>
                    <v-flex sm7 md7 lg7 xl7>
                      <v-layout>
                        <v-text-field
                          v-model="search"
                          solo
                          :label="$t('Task.allTask.placeholderSearchProject')"
                          clearable
                          append-icon="search"
                          class="searchBox"
                        ></v-text-field>
                        
                        <v-btn class="btn-create-task"   @click="open_create_task()" >
                          <v-icon left class="icon-create-task">fas fa-plus</v-icon>
                            <span>{{$t('Task.allTask.createTask')}}</span>
                        </v-btn>
                      </v-layout>

                      <v-layout wrap  align-center justify-center fill-height style="background-color:#f4f1f1; border-radius: 20px" class="mr-3 mt-3">
                          <v-layout align-start justify-end row fill-height style="height: calc(80vh - 280px) !important; overflow-y: auto;" class="taskScroll" >
                            <v-flex>
                              <v-layout v-if="progress_project" justify-center align-center  style="height: 45vh !important; ">
                                <v-progress-circular :size="40" :indeterminate="progress_project" color="primary"></v-progress-circular>
                              </v-layout>
                              <v-layout class="mr-3 ml-3" v-for="(item,i) in FilterListProject" :key="i" column v-else-if="listproject.length != 0">
                                <v-layout row wrap class="mb-2 mt-2" v-if="listproject.length != 0">
                                  <h3 class="text-overflow-projectname">{{item.project_name}}</h3>
                                  <v-spacer></v-spacer>
                                  <span class="text-overflow-groupname">{{item.room_name}}</span>
                                </v-layout>
                              <v-expansion-panel>
                                <v-expansion-panel-content v-for="(state,index) in item.state" v-if="state.member.length != 0" expand-icon="mdi-menu-down">
                                  <div slot="header" v-if="state.member.length != 0">{{state.name}}
                                    <span class="span-numtask">{{$t('Task.allTask.numTask',{count: state.member.length})}}</span>
                                  </div>
                                  <v-card>
                                    <v-list>
                                      <template v-for="(member, indexmember) in state.member">
                                        <v-list-tile  
                                          avatar 
                                          :key="member._id" 
                                          @click="open_detail_task(member._id, listproject[i].tokenroom)"
                                          :class="checkpriorityTask(member.priority)">
                                            <v-list-tile-content>
                                              <v-list-tile-title>
                                                <v-layout row wrap>
                                                  <span class="pl-2">{{member.title}}</span>
                                                  <v-spacer></v-spacer>
                                                  <v-icon color="#d8d8d8" style="font-size: 19px;" v-if="member.count_comment != '0'">fas fa-comment-dots</v-icon>
                                                  <span class="ml-2 mr-2" style="color: #515050; font-size: 13px;" v-if="member.count_comment != '0'">{{member.count_comment}}</span>
                                                  <span class="ml-3" style="color: #515050; font-size: 13px;">{{datetime(member.time_end)}}</span>
                                                </v-layout>
                                              </v-list-tile-title>
                                            </v-list-tile-content>
                                        </v-list-tile>
                                        <v-divider v-if="indexmember + 1 < state.member.length" :key="indexmember"></v-divider>
                                      </template>
                                    </v-list>
                                  </v-card>
                                </v-expansion-panel-content>
                              </v-expansion-panel>
                              </v-layout>
                              <v-layout row wrap align-center justify-center fill-height v-else class="mt-5">
                                <h4 >{{$t('Task.allTask.noCardTask')}}</h4>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                      </v-layout>
                    </v-flex> -->
                  </v-layout> 
                </v-flex>
              </v-layout>
            </v-layout>
          </v-container>
        </v-content>
      </v-flex>
    </v-layout>
    <CreateTask :dialogCreateTaskCalendar="dialogCreateTaskCalendar" @closeCreateTask="closeCreateTask" @createdtask="createdtask"></CreateTask>
    <DetailTask :dialogDetailTask="dialogDetailTask" @closeDetailTask="closeDetailTask" :taskid="taskid" @edittask="edittask" @deletetask="deletetask" @commenttask="commenttask" :roomid="roomid"></DetailTask>

  </v-container>
</template>

<script>
import { sync } from 'vuex-pathify'
import { Decode, Momenttime } from '@/services'
import Rightside from '@/components/chat/layout/RightSide'
import CreateTask from '@/components/chat/manage_task/created_task_calendar_dialog'
import DetailTask from '@/components/chat/manage_task/detail_task_dialog'
// import DetailTask from '@/components/chat/manage_task/test_detail_task_dialog'

var _ = require('lodash')
var moment = require('moment')
export default {
  props: {
    source: String
  },
  components: {
    Rightside,
    CreateTask,
    DetailTask
  },
  data () {
    return {
      dialogDetailProject: false,
      dialogDetailTask: false,
      dialogCreateTaskCalendar: false,
      status_login: '',
      windowWidth: '',
      mini: true,
      dialog: false,
      drawer: true,
      search: '',
      detail: {},
      token: '',
      detail_project: {},
      progress: false,
      projectid: '',
      state_id: '',
      member: [],
      taskid: '',
      roomid: '',
      arrayEvents: null,
      date1: null,
      date2: new Date().toISOString().substr(0, 10),
      listproject: [],
      time_now: new Date().toISOString().substr(0, 10),
      time_day: new Date().toISOString().substr(0, 10),
      progress_project: false,
      date: new Date().toISOString().substr(0, 10),
      list_date_task: [],
      monthLater: '',
      list_project_month: [],
      listdateCalendar: [],

      start: new Date().toISOString().substr(0, 10),
      listdataTask: [],
      listGetproject: [],
      checkListstr: [],
      checkdates: new Date().toISOString().substr(0, 10),
      checkroomname: '',
      progress_task: false
    }
  },
  mounted () {
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.windowWidth = window.innerWidth
      })
    })
  },
  created () {

    var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    this.token = decoded['tokenuser']
    this.status_login = decoded['status_login']
    this.progress_project = true
    this.get_task_in_month(this.time_now)
    // this.get_data_room()
    // this.get_task_in_day()
  },
  computed: {
    ...sync('*'),
    FilterListProject () {
      if (this.search !== '' && this.search !== null) {
        return this.listproject.filter(post => {
          return post.project_name.toLowerCase().includes(this.search.toLowerCase())
        })
      } else {
        return this.listproject
      }
    },
    // eventsMap () {
    //   const map = {}
    //   this.events.forEach(e => (map[e.date] = map[e.date] || []).push(e))
    //   console.log(map)
    //   return map
    // }
  },
  watch: {
    date2 () {
      if (this.date.split('-')[1] !== this.date2.split('-')[1]) {
        this.progress_project = true
        this.checkdates = this.date
        this.date = this.date2
        this.time_day = this.date2
        localStorage.setItem('datestart', this.time_day)
        this.get_task_in_month(this.time_day)
        // this.get_task_in_day()
        // this.check_range_date()
      } else {
        this.date = this.date2
        this.checkdates = this.date2
      }
    },
    windowWidth () {
      if (this.windowWidth <= 960) {
        this.$router.push('/mobile/homepage')
      }
    },
    socketmessage (data) {
      // console.log(data)
      // if (data.tokenuser !== this.token) {
      //   if (data.message == 'create_task') {
      //     this.get_task_by_id(data.task_id, data.state.state_id, 'create')
      //   }
      // }
    },
    socket_deletetask (data) {
      // console.log(data)
      if (data.tokenuser !== this.token) {
        this.get_task_in_month(this.time_day)
        // this.get_task_in_day()
      }
    },
    socket_edittask (data) {
      // console.log(data)
      if (data.tokenuser !== this.token) {
        this.get_task_in_month(this.time_day)
        // this.get_task_in_day()
      }
    }
  },
  methods: {
    open_create_project () {
      this.$router.push('/chat/project/create_project')
    },
    datetimecheck (timecheck) {
      if (timecheck.split('-')[1] !== this.checkdates.split('-')[1]) {
        let timeTH = Momenttime.momentdatethai(timecheck).split(' ')[1] + ' ' + Momenttime.momentdatethai(timecheck).split(' ')[2]
        let timeEN = Momenttime.momentdateen(timecheck).split(' ')[0] + ' ' + Momenttime.momentdateen(timecheck).split(' ')[2]
        return (this.$i18n.locale == 'th')? timeTH: timeEN
      } else {
        return (this.$i18n.locale == 'th')? Momenttime.momentdatethai(timecheck): Momenttime.momentdateen(timecheck)
      }
    },
    datetime (timestamp) {
      return (this.$i18n.locale == 'th')? Momenttime.momentdatethai(timestamp): Momenttime.momentdateen(timestamp)
    },
    get_task_in_month (time_now) {
      this.axios.post(process.env.APIpub + '/v1/user/get_task_in_month', {
        tokenuser: this.token,
        time_now: time_now + ' 00:00:00.000000'
      }).then((response) => {
        // console.log(response.data.data)
        if (response.data.status === 'success') {
          this.list_project_month = response.data.data
          this.check_range_date()
        }
      })
    },
    get_task_in_day (time, projectname) {
      this.listproject = []
      this.progress_task = true
      // this.progress_project = true
      this.axios.post(process.env.APIpub + '/v1/user/get_task_in_day', {
        tokenuser: this.token,
        time_day: time + ' 00:00:00.000000'
      }).then((response) => {
        if (response.data.status === 'success') {
          // this.progress_project = false
          localStorage.setItem('datestart', this.time_day)
          if (projectname) {
            this.checkroomname = projectname
            let checkroomname = response.data.data
            const arrtask = checkroomname.filter(task => task.room_name == projectname)
            this.listproject = arrtask
            this.progress_task = false
          } else {
            this.checkroomname = ''
            this.listproject = response.data.data
            this.progress_task = false
          }
          // console.log(this.listproject)
        }
      })
    },
    functionEvents (date) {
      // console.log(date)
      var month = date.split('-')[0] + '-' + date.split('-')[1]
      if (month !== this.monthLater) {
        this.monthLater = month
        this.time_now = month + '-01'
        this.get_task_in_month(this.time_now)
        return this.checkdate(date)
      } else {
        return this.checkdate(date)
      }
    },
    functionEventsColor () {
      return 'green darken-1'
    },
    check_range_date () {
      // console.log(this.list_date_task)
      this.listGetproject = []
      this.listdataTask = []
      this.listdateCalendar = []
      var time_end = '', time_start = ''
      for (var i = 0; i < this.list_project_month.length; i++) {
        for (var j = 0; j < this.list_project_month[i].state.length; j++) {
          for (var k = 0; k < this.list_project_month[i].state[j].member.length; k++) {
            time_start = this.list_project_month[i].state[j].member[k].time_start.split(' ')[0]
            time_end = this.list_project_month[i].state[j].member[k].time_end.split(' ')[0]
            this.listdateCalendar = _.union(this.listdateCalendar.concat(this.getDates(time_start, time_end, this.list_project_month[i].room_name)))
            // this.get_user_create(this.listdateCalendar)
          }
        }
      }
      this.checkIncludes()
    },
    getDates(startDate, stopDate, project) {
      // console.log(startDate, stopDate)
      var dateArray = [];
      var currentDate = moment(startDate);
      var stopDate = moment(stopDate);
      while (currentDate <= stopDate) {
        this.listGetproject.push({
          task: project,
          time: moment(currentDate).format('YYYY-MM-DD'),
          dialog: false
        })  
        dateArray.push( moment(currentDate).format('YYYY-MM-DD') )
        currentDate = moment(currentDate).add(1, 'days');
      }
      return dateArray;
    },
    checkIncludes () {
      var arr = []
      arr = this.listGetproject.filter((value, index, self) =>
        index === self.findIndex((t, i) => (
          t.task === value.task && t.time === value.time
        ))
      )

      var output = []
      var existingIndex = []
      arr.forEach(function(item) {
        var existing = output.filter(function(v, i) {
          return v.time == item.time;
        });
        if (existing.length) {
          existingIndex = output.indexOf(existing[0]);
          output[existingIndex].task = output[existingIndex].task.concat(item.task);
        } else {
          if (typeof item.task == 'string')
            item.task = [item.task];
          output.push(item);
        }
      });

      this.listdataTask = output
      this.progress_project = false
    },
    checkdate (date) {
      // console.log(date)
      // console.log(this.listdateCalendar)
      var test = []
      test = this.listdateCalendar
      if (test.includes(date) || test.includes(date)) {
        return true
      } else {
        return false
      }
    },
    momentday (timestamp) {
      return Momenttime.momentdatethai(timestamp)
    },
    commenttask (data) {
      var index = _.findIndex(this.listproject, function(o) { return o._id == data.project_id })
      var index_state = _.findIndex(this.listproject[index].state, function(o) { return o.state_id == data.state_id })
      var index_member = _.findIndex(this.listproject[index].state[index_state].member, function(o) { return o._id == data.task_id })
      this.listproject[index].state[index_state].member[index_member].count_comment = data.count_comment
    },
    checkpriorityTask (priority) {
      if (priority == '1' || priority == '2' || priority == '3') {
        return 'card-task-pri' + priority
      } else {
        return 'card-task-pri3'
      }
    },
    createdtask (data) {
      // console.log(data)
      this.get_project_by_id(data)
      // console.log(this.list_project_month)
    },
    closeCreateTask(value) {
      this.dialogCreateTaskCalendar = value
    },
    edittask (data) {
      // console.log(data)
      // console.log(this.list_project_month)
      // this.get_task_in_day()
      var date = data.date_end + ' 00:00:00'
      var date_start = data.date_start + ' 00:00:00'
      var index = _.findIndex(this.list_project_month, function(o) { return o._id == data.project_id })
      var index_state = _.findIndex(this.list_project_month[index].state, function(o) { return o.state_id == data.state_id })
      var index_member = _.findIndex(this.list_project_month[index].state[index_state].member, function(o) { return o._id == data.task_id })
      this.list_project_month[index].state[index_state].member[index_member].time_end = date
      this.list_project_month[index].state[index_state].member[index_member].time_start = date_start
      this.check_range_date()
    },
    deletetask (data) {
      // this.get_task_in_day()
      var date = data.date_end
      date = date.split(' ')[0]
      var indexcalendar = _.findIndex(this.listdateCalendar, function(o) { return o == date })
      var index = _.findIndex(this.list_project_month, function(o) { return o._id == data.project_id })
      var index_state = _.findIndex(this.list_project_month[index].state, function(o) { return o.state_id == data.state_id })
      var index_member = _.findIndex(this.list_project_month[index].state[index_state].member, function(o) { return o._id == data.task_id })
      this.list_project_month[index].state[index_state].member.splice(index_member, 1)
      // console.log(this.list_project_month)
      this.check_range_date()
    },
    closeDetailTask(value) {
      this.dialogDetailTask = value
    },
    open_create_task () {
      this.dialogCreateTaskCalendar = true
    },
    open_detail_task (taskid, tokenroom) {
      this.dialog = false
      // console.log(tokenroom)
      this.taskid = taskid
      this.roomid = tokenroom
      // console.log(this.StateId)
      this.dialogDetailTask = true
    },
    toChatroom () {
      this.$router.push('/chat/room/project/' + this.$route.params.roomid)
    },
    get_data_room () {
      this.detail = {}
      this.progress = true
      this.axios.post(process.env.APImanage + '/getroom', {
        tokenuser: this.token,
        tokenroom: this.$route.params.roomid
      }).then((response) => {
        // console.log(response.data)
        if (response.data.status === 'success') {
          this.progress = false
          this.detail = response.data
          var member = []
          member = response.data.data_room
          this.member = _.filter(member, function(o) { return o.statemember == 'active' })
          this.get_task_in_day()
          // this.get_project_by_id(this.$route.params.projectid)
        }
      })
    },
    get_project_by_id (data) {
      // console.log(data)
      this.listGetproject = []
      this.axios.post(process.env.APIpub + '/v1/user/get_project_by_id', {
        tokenuser: this.token,
        tokenroom: data.tokenroom,
        project_id: data.projectid
      }).then((responsed) => {
        if (responsed.data.status == 'success') {
          this.projectid = data.projectid
          // this.detail_project = responsed.data.data
          this.list_project_month.unshift(responsed.data.data)
          // console.log(this.listproject)
          // console.log(this.list_project_month)
          var date = data.date_end + ' 00:00:00'
          var date_start = data.date_start + ' 00:00:00'
          var index = _.findIndex(this.list_project_month, function(o) { return o._id == data.projectid })
          var index_state = _.findIndex(this.list_project_month[index].state, function(o) { return o.state_id == data.state_id })
          var index_member = _.findIndex(this.list_project_month[index].state[index_state].member, function(o) { return o._id == data.task_id })
          this.list_project_month[index].state[index_state].member[index_member].time_end = date
          this.list_project_month[index].state[index_state].member[index_member].time_start = date_start
          this.get_task_in_day()
          this.get_task_in_month(this.date2)
          // this.check_range_date()
          // console.log(this.listproject)
        }
      })
    },
    get_task_by_id (taskid, stateid, stateevent, oldstate) {
      this.axios.post(process.env.APIpub + '/v1/user/get_task_by_id', {
        tokenuser: this.token,
        task_id: taskid
      }).then((responsed) => {
        if (responsed.data.status == 'success') {
          // console.log(responsed.data.data)
          // this.list_project_month.unshift(responsed.data.data)
          var old_index = ''
          var index_member = ''
          var index = ''
          if (stateevent == 'edit') {
            old_index = _.findIndex(this.detail_project.state, function(o) { return o.state_id == oldstate })
            index_member = _.findIndex(this.detail_project.state[old_index].member, function(o) { return o._id == taskid })
            index = _.findIndex(this.detail_project.state, function(o) { return o.state_id == stateid })
            this.detail_project.state[old_index].member.splice(index_member, 1)
            this.detail_project.state[index].member.unshift(responsed.data.data)
          } else if (stateevent == 'create') {
            index = _.findIndex(this.detail_project.state, function(o) { return o.state_id == stateid })
            this.detail_project.state[index].member.unshift(responsed.data.data)
          }
        }
      })
    }
  }
}
</script>
<style type="text/css" scoped>
>>>.v-menu__content {
  border-radius: 20px !important;
}
.btn_prev_next {
  font-size: 13px !important;
  border-radius: 30px !important;
  margin-left: 0vw !important;
  margin-right: 10px !important;
  background: #ffffff !important;
  color: #4268fb !important;
  width: 120px !important;
  border-style: solid !important;
  border-color: #4268fb !important;
  box-shadow: none !important;
  text-transform: none;
}
.my-event {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-radius: 2px;
  background-color: #1867c0;
  color: #ffffff;
  border: 1px solid #1867c0;
  width: 100%;
  font-size: 12px;
  padding: 3px;
  cursor: pointer;
  margin-bottom: 1px;
}
.span-numtask {
  border-style: solid !important;
  background-color: rgba(24, 103, 192, 0.12) !important;
  border-width: thin !important;
  border-color: rgba(24, 103, 192, 0.12) !important;
  border-radius: 6px !important;
  padding-left: 4px !important;
  padding-right: 4px !important;
  color: #1867c0 !important;
}
>>>.theme--light.v-expansion-panel .v-expansion-panel__container {
  border-top: none !important;
  background-color: #fff !important;
  color: rgba(0,0,0,.87) !important;
  border-radius: 15px !important;
  margin-top: 5px !important;
}
>>>.v-expansion-panel {
    display: flex !important;
    flex-wrap: wrap !important;
    justify-content: center !important;
    list-style-type: none !important;
    padding: 0 !important;
    text-align: left !important;
    width: 100% !important;
    box-shadow: none !important;
}
>>>.v-list {
  max-width: 100% !important;
}
.flex-center {
  justify-content: center !important;
  align-items: center !important;
  display: flex !important;
}
.color-numtask {
  color: rgb(170, 170, 170) !important;
}
.scrolling-wrapper {
  overflow-x: scroll !important;
  overflow-y: hidden !important;
  height: 29vh !important;
  max-width: 70vw !important;
  display: -webkit-inline-box !important;
  padding-top: 5vh !important;
}
.scrolling-wrapper::-webkit-scrollbar {
  height: 5px;
  width: 8px;
}
.scrolling-wrapper::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: rgba(0, 0, 0, .1);
}
.CSChatThai {
  font-family: 'CS ChatThaiUI' !important;
  word-wrap: break-word;
}
.text-transform {
  /* text-transform: uppercase; */
  text-transform: capitalize !important;
}
.btn-plus-user {
  background-color: #efefef !important;
  color: #1d1d1d !important;
  box-shadow: none !important;
}
.font-size18 {
  font-size: 18px !important;
}
.font-title-task {
  font-size: 16px!important;
  font-weight: 500!important;
  /* padding-left: 20px!important; */
  padding-top: 12px!important;
}
>>>.v-card__title--primary {
  padding-top: 18px !important;
}
.card-task-pri1 {
  border-left-color: #b3493d !important;
  border-left-style: solid !important;
  border-left-width: 10px !important;
}
.card-task-pri2 {
  border-left-color: #fcbe55 !important;
  border-left-style: solid !important;
  border-left-width: 10px !important;
}
.card-task-pri3 {
  border-left-color: #a0a1a3 !important;
  border-left-style: solid !important;
  border-left-width: 10px !important;
}
.overflow-scroll {
  overflow-y: scroll !important;
}
.object-fit-img {
  object-fit: cover;
  object-position: 50% 0;
}
.border-img {
  border-color: grey !important;
  border-style: solid !important;
  border-width: thin !important;
}
.margin-top-120px {
  margin-top: 120px !important;
}
.text-overflow {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  width: 250px !important;
  text-align: center !important;
}
.text-overflow-groupname {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  width: 180px !important;
  text-align: right !important;
}
.text-overflow-projectname {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  /* width: 180px !important; */
  /* text-align: center !important; */
}
.text-overflow-list {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  width: 190px !important;
}
.color-white {
  color: white !important;
}
/* >>>.v-list__tile__content {
  height: 70vh;
  margin-top: 50px;
} */
.height-100vh {
  height: 100vh !important;
}
.height-200px {
  height: 200px !important;
}
.height-300px {
  height: 300px !important;
}
.width-100 {
  width: 100% !important;
}
.color-card-task {
  overflow-y: scroll !important;
  overflow-x: hidden !important;
  height: 85vh !important;
  /* margin-top: 20px !important; */
  border-radius: 6px !important;
  /* background-color: #f1f1f1 !important; */
  background-image: linear-gradient(to right, rgba(192, 203, 250, 0.808),rgb(178, 208, 216)) !important;
  width: 1000px !important;
}
.color-card-task::-webkit-scrollbar {
  height: 5px;
  width: 8px;
}
.color-card-task::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: rgba(0, 0, 0, .1);
}
.system-bar {
  height: 4px !important;
  background-color: #e0e0e0 !important;
  border-radius: 10px !important;
  /* margin-left: 18px !important; */
}
.font-size-16 {
  font-size: 16px !important;
}
.ml-50 {
  margin-left: 50px !important;
}
.span-clear-filter {
   color: #949494 !important;
   font-size: 16px !important;
}
>>>.v-input__slot {
  border-radius: 13px !important;
  box-shadow: none !important;
  background-color: rgba(142, 142, 147, 0.12156862745098039) !important;
}
.btn-filter-task {
  border-radius: 6px !important;
  border: solid 1px #2562af !important;
  color: #2562af !important;
  background-color: white !important;
  box-shadow: none !important;
}
.icon-filter-task {
  color: #2562af !important;
  font-size: 16px !important;
}
.icon-create-task{
  color: white !important;
  font-size: 16px !important;
}
.btn-create-task {
  text-transform: none !important;
  background-color: #2561b0 !important;
  /* border-color: #2561b0 !important; */
  border-style: #2561b0 solid !important;
  border-radius: 6px !important;
  color: white !important;
  box-shadow: none !important;
  margin-right: 20px;
  /* margin-top: 10px; */
}
.btn-nav {
  background-color: #d8d8d8 !important;
}
>>>.v-list .v-list--dense .theme--light {
  margin-top: 70px !important;
}
.bg-flex-1 {
  background-color: #1b232d;
}
.container{
  padding: 0px !important;
}
.fixed-content {
  min-height:100%;
  /*position:fixed;*/
  overflow-y:scroll;
  overflow-x:hidden;
}
.content {
  padding: 0px 0px 0px !important;
}
>>>.chatboxnonselect {
  width: 100%;
  min-width: 10vw;
  height: calc(100vh - 64px);
  background-color:white;
  overflow-y: hidden;
}
.btn-color {
  text-transform: none !important;
  background-color: white !important;
  border-color: #2561b0 !important;
  border-style: solid !important;
  border-radius: 6px !important;
  color: #2561b0 !important;
  box-shadow: none !important;
}
.icon-color {
  color: #2561b0 !important;
}
>>> .theme--light.v-card {
  background-color: #fff;
  color: rgba(0,0,0,.87);
  /* border-radius: 20px !important; */
}
>>>.cardstyle.theme--light.v-card {
 background-color: transparent;
 border-color: rgb(103, 240, 240) !important;
 /* border-radius: none !important; */
}
.taskScroll::-webkit-scrollbar {
  height: 5px;
  width: 8px;
}
.taskScroll::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: rgba(0, 0, 0, .1);
}
.searchBox{
  margin-right: 20px;
}
>>>.v-text-field.v-text-field--enclosed .v-text-field__details {
    display: none;
}
>>>.v-text-field>.v-input__control>.v-input__slot {
  background-color: rgb(246, 246, 246) !important;
}

>>>.v-text-field.v-text-field--solo .v-label {
  font-size: 14px;
}
.backgroundimage {
  border-radius: 20px;
}

</style>



// WEBPACK FOOTER //
// src/components/chat/manage_task/homepage_calendar.vue